import { connect } from 'dva'
import AntEmptyContent from './AntEmptyContent'
import AntdBaseTable from './AntdBaseTable'
import TableWWithToolbar from './TableWWithToolbar'
import StickyFootBar from './StickyFootBar'

export { AntdBaseTable, AntEmptyContent, StickyFootBar, TableWWithToolbar }

const DEFAULT_CONFIG = {}

const mapStateToProps = ({ user: { config } }, ownProps) => {
    return {
        config: (config && ownProps.configKey && config[ownProps.configKey]) || DEFAULT_CONFIG
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setConfig(configKey, configValue) {
            return dispatch({
                type: 'user/addConfig',
                payload: {
                    configKey,
                    configValue
                }
            })
        },
        setShowBackTop(affixed) {
            dispatch({
                type: 'global/setShowBackTop',
                payload: affixed
            })
        }
    }
}

export const ConfigurableTable = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
    TableWWithToolbar
)

export function transformSelectedRowKeysToSelectedRows<T>(selectedRowKeys: string[], dataSource: T[], rowKey: string) {
    const stringSelectRowKeys = [...selectedRowKeys].map(item => String(item))
    return dataSource.filter(item => stringSelectRowKeys.indexOf(String(item[rowKey])) > -1)
}

export function transformSelectedRowKeysToSelectedRowsSingle<T>(
    selectedRowKeys: string,
    dataSource: T[],
    rowKey: string
) {
    const stringSelectRowKeys = String(selectedRowKeys)
    return dataSource.find(item => String(item[rowKey]) === stringSelectRowKeys) || {}
}
